export enum ActionObjectType {
  VIDEO = 'VIDEO',
  SEQUENCE = 'SEQUENCE',
}
